import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import {
  TableBuilderFactory,
  TableComponent,
  TableConfig,
  TableDataPayload,
} from '@web/shared/ui';
import { Observable } from 'rxjs';
import { WarehouseOwnerCollectionItem } from '../../models/warehouse-owner-collection-item';
import { WarehouseOwnerDataSourceService } from '../../services/warehouse-owner-data-source.service';
import { WarehouseOwnerCollectionFilter } from '../../models/warehouse-owner-collection-filter';

@Component({
  selector: 'app-warehouse-owner-list',
  imports: [TableComponent],
  templateUrl: './warehouse-owner-list.component.html',
  styleUrl: './warehouse-owner-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseOwnerListComponent {
  /* prettier-ignore */
  private readonly tableBuilder = inject(TableBuilderFactory<WarehouseOwnerCollectionItem, WarehouseOwnerCollectionFilter>).create();
  /* prettier-ignore */
  private readonly warehouseOwnerDataSource = inject(WarehouseOwnerDataSourceService);

  protected readonly config = this.buildTable();

  private buildTable(): TableConfig<
    WarehouseOwnerCollectionItem,
    WarehouseOwnerCollectionFilter
  > {
    return this.tableBuilder
      .dataKey('id')
      .columns((builder) => [
        builder //
          .initText('label')
          .filterKey('label')
          .sortKey('label')
          .filterable(true)
          .sortable(true)
          .label('Etykieta')
          .build(),

        builder
          .initDate('createdAt')
          .filterKey('createdAt')
          .sortKey('createdAt')
          .filterable(true)
          .sortable(true)
          .label('Data utworzenia')
          .build(),
      ])
      .filters((builder) => [
        builder.initDateRange('createdAt').build(),
        builder.initText('label').build(),
      ])
      .dataSource({
        fetch: (
          lazyLoad,
        ): Observable<TableDataPayload<WarehouseOwnerCollectionItem>> =>
          this.warehouseOwnerDataSource.fetchCollection(lazyLoad),
      })
      .build();
  }
}
